export const formatFileSize = (size: number | null) => (size ? `${Math.max(1, Math.round(size / 1024))} KB` : '')

export const gridSx = {
  backgroundColor: '#ede9e4',
  borderRadius: '0px',
  border: 'none',
  '.MuiDataGrid-columnHeaders': { backgroundColor: '#fc7f03', borderRadius: '0px', border: '0px' },
  '.MuiDataGrid-columnHeaderTitleContainer': { color: '#fff', fontSize: '15px', justifyContent: 'center' },
  '.MuiDataGrid-cell': { border: '1px solid #fc7f03', padding: '8px 5px', justifyContent: 'center' },
  '.MuiDataGrid-row': { cursor: 'default' },
}
